import React, {useState} from "react";
import {responsibilityApiTYpe} from "../../../../ticketsystem/API/request/responsibility.Api,interface";
import {ResponseRecordAll} from "../../../API/response/ticketsystem2";
import SortableTabHeader, {SortOrder} from "../SortableTabHeader";
import Table from "react-bootstrap/Table";
import {dateFormat, IntlMessage, MIcon} from "../../../../../@WUM/core/Elements";
import {SpinnerJSX} from "../../../../ticketsystem/modules/components/Spinner";
import {useNavigate} from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import PaginationApi from "../PaginationAPI";
import Form from "react-bootstrap/Form";
import {truncateText} from "../../../../../@WUM/core/Function";
import {WorkLogCommentModal} from "../TicketTimeTracking/WorkLogCommentModal";
import {WorkLogEntry} from "../../../API/request/ticket.interface";
import {ToastFn} from "../../../../worktimetracking/Pages/components/save/SubmitHandler";

interface TimeTrackingCompleteOverviewTableProps {
    Store: any
    users?: responsibilityApiTYpe[]
    showToast: ToastFn;
}

export type TimeTrackingFilterMode = 'year' | 'dateRange' | 'singleDate';

export const TimeTrackingCompleteOverviewTable = (props: TimeTrackingCompleteOverviewTableProps): JSX.Element => {

    const {Store, users, showToast} = props;

    const navigate = useNavigate();

    const currentYear = new Date().getFullYear().toString();

    const [showCommentModal, setShowCommentModal] = useState<boolean>(false);
    const [selectedEntry, setSelectedEntry] = useState<WorkLogEntry | null>(null);

    const handleShowCommentModal = (entry: WorkLogEntry): void => {
        setSelectedEntry(entry);
        setShowCommentModal(true);
    };

    const handleCloseCommentModal = (): void => {
        setShowCommentModal(false);
        setSelectedEntry(null);
    };

    const [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [column, setColumn] = useState("created_at");

    const [order, setOrder] = useState<SortOrder>('DESC');

    const [filterMode, setFilterMode] = useState<TimeTrackingFilterMode>('year');
    const [year, setYear] = useState(currentYear);
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [singleDate, setSingleDate] = useState('');

    const [fetchData, setFetchData] = useState(0); // just sets a timestamp

    const responseRecordAll = ResponseRecordAll(
        filterMode,
        limit,
        pageNumber,
        order,
        column,
        year,
        singleDate,
        dateFrom,
        dateTo,
        fetchData
    );

    let DataHolder = [];

    const userById: Record<number, responsibilityApiTYpe> = {};
    users?.forEach((user) => {
        userById[user.id] = user;
    });

    const handleFilterModeChange = (nextFilterMode: TimeTrackingFilterMode): void => {
        setFilterMode(nextFilterMode);
        setPageNumber(1);
    };

    const handleYearChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setYear(event.target.value);
        setPageNumber(1);
        setFetchData(Date.now());
    };

    const reloadRow = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const nextLimit = parseInt(event.target.value, 10);

        setLimit(nextLimit);
        setPageNumber(1);
        setFetchData(Date.now());
    };


    if (typeof responseRecordAll !== "boolean" && responseRecordAll !== undefined) {

        if (responseRecordAll.pagination.maxElements === 0) {
            DataHolder.push(
                <tr>
                    <td colSpan={6}>
                        Keine Einträge gefunden
                    </td>
                </tr>
            )
        }


        const responseData = responseRecordAll.data

        if (responseRecordAll.pagination.maxElements > 0) {
            for (let rowIndex = 0; rowIndex < responseData.length; rowIndex++) {
                const Data = responseData[rowIndex];
                const badge = Data.billable ? (
                    <span className="badge bg-success"><MIcon className={"d-flex m-0 fs-6"} children={"check"}/></span>
                ) : (
                    <span className="badge bg-secondary"><MIcon className={"d-flex m-0 fs-6"}
                                                                children={"close"}/></span>
                );

                const calculatedTime = (Data.totalMinutes / 60).toFixed(2)

                const user = userById[Data.employeeId];

                const userAvatar = <Avatar
                    alt={user?.username ?? ''}
                    title={user?.username ?? ''}
                    src={user?.media ?? ''}
                    className={'cardAvatarMini'}
                />

                const hasTicket = Data.ticket?.id !== undefined && Data.ticket?.id !== null;

                DataHolder.push(
                    <>
                        <tr
                            key={Data.id}
                            onDoubleClick={hasTicket ? () => navigate(`/ticket/single/ticketsystem/${Data.ticket?.id}`) : undefined}
                            className={hasTicket ? "pointer" : ""}
                        >
                            <td>{
                                dateFormat(
                                    Data.created_at,
                                    localStorage.getItem('locale'),
                                    'us',
                                    true,
                                    "onlyDate",
                                    Store
                                )
                            }</td>
                            <td>{
                                dateFormat(
                                    Data.workAt,
                                    localStorage.getItem('locale'),
                                    'us',
                                    false,
                                    "onlyDate",
                                    Store
                                )
                            }</td>
                            <td className={"text-end"}>{calculatedTime}</td>
                            <td>{badge}</td>
                            <td>{truncateText(Data.ticket?.regard, 35)}</td>
                            <td>{userAvatar}</td>
                        </tr>
                        <tr className={"border-top-0"} onClick={(): void => handleShowCommentModal(Data)}>
                            <td>
                            <span title={"Aktivitätsbericht"}>
                                    <MIcon className={"fs-6 me-2"} children={"article"}  style={{cursor: "help"}}/>
                            </span>
                            </td>
                            <td colSpan={6} className={"text-start border-0"}>
                            <span title={Data.activity_report.content}>
                                {truncateText(Data.activity_report.content, 90)}
                            </span>
                            </td>
                        </tr>
                    </>

                )
            }
        }


        return (
            <>
                <div className="card border-0 shadow-sm mb-3">
                    <div className="card-body">
                        <div className="d-flex flex-wrap align-items-end gap-3">
                            <div>
                                <label className="form-label mb-1">
                                    Zeitraum
                                </label>
                                <div className="btn-group d-flex" role="group">
                                    <button
                                        type="button"
                                        className={`btn ${filterMode === 'year' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleFilterModeChange('year')}
                                    >
                                        Jahr
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${filterMode === 'dateRange' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleFilterModeChange('dateRange')}
                                    >
                                        Von/Bis
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn ${filterMode === 'singleDate' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleFilterModeChange('singleDate')}
                                    >
                                        Tag
                                    </button>
                                </div>
                            </div>

                            {filterMode === 'year' && (
                                <div style={{minWidth: '160px'}}>
                                    <label className="form-label mb-1" htmlFor="timeTrackingYear">
                                        Jahr
                                    </label>
                                    <input
                                        id="timeTrackingYear"
                                        type="number"
                                        className="form-control"
                                        min="2000"
                                        max="2100"
                                        value={year}
                                        onChange={handleYearChange}
                                    />
                                </div>
                            )}

                            {filterMode === 'dateRange' && (
                                <>
                                    <div style={{minWidth: '180px'}}>
                                        <label className="form-label mb-1" htmlFor="timeTrackingDateFrom">
                                            Von
                                        </label>
                                        <input
                                            id="timeTrackingDateFrom"
                                            type="date"
                                            className="form-control"
                                            value={dateFrom}
                                            onChange={(event) => {
                                                setDateFrom(event.target.value);
                                                setPageNumber(1);
                                                setFetchData(Date.now());
                                            }}
                                        />
                                    </div>

                                    <div style={{minWidth: '180px'}}>
                                        <label className="form-label mb-1" htmlFor="timeTrackingDateTo">
                                            Bis
                                        </label>
                                        <input
                                            id="timeTrackingDateTo"
                                            type="date"
                                            className="form-control"
                                            value={dateTo}
                                            onChange={(event) => {
                                                setDateTo(event.target.value);
                                                setPageNumber(1);
                                                setFetchData(Date.now());
                                            }}
                                        />
                                    </div>
                                </>
                            )}

                            {filterMode === 'singleDate' && (
                                <div style={{minWidth: '180px'}}>
                                    <label className="form-label mb-1" htmlFor="timeTrackingSingleDate">
                                        Tag
                                    </label>
                                    <input
                                        id="timeTrackingSingleDate"
                                        type="date"
                                        className="form-control"
                                        value={singleDate}
                                        onChange={(event) => {
                                            setSingleDate(event.target.value);
                                            setPageNumber(1);
                                            setFetchData(Date.now());
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Table hover striped={true}>
                    <thead>
                    <tr style={{background: '#F3F3F3', height: '60px'}}>
                        <SortableTabHeader
                            label={<IntlMessage messageId="ticket.report.date" Store={Store}/>} columnName="created_at"
                            column={column} order={order} setColumn={setColumn} setOrder={setOrder}
                            setPageNumber={setPageNumber} setFetchData={setFetchData} style={{width: '10%'}}/>
                        <SortableTabHeader label={<IntlMessage messageId="ticket.work.date" Store={Store}/>}
                                           columnName="start_at" column={column} order={order} setColumn={setColumn}
                                           setOrder={setOrder} setPageNumber={setPageNumber} setFetchData={setFetchData}
                                           style={{width: '10%'}}/>
                        <SortableTabHeader
                            label={<IntlMessage messageId="ticket.work.time" Store={Store}/>} columnName="stop_at"
                            column={column} order={order} setColumn={setColumn} setOrder={setOrder}
                            setPageNumber={setPageNumber} setFetchData={setFetchData} style={{width: '10%'}}/>
                        <SortableTabHeader label={<IntlMessage messageId="ticket.work.billable" Store={Store}/>}
                                           columnName="billable" column={column} order={order} setColumn={setColumn}
                                           setOrder={setOrder} setPageNumber={setPageNumber} setFetchData={setFetchData}
                                           style={{width: '10%'}}/>
                        <th style={{
                            background: '#F3F3F3',
                            verticalAlign: 'middle',
                            cursor: 'pointer',
                            userSelect: 'none',
                        }}><IntlMessage messageId="inbox.subject" Store={Store}/></th>
                        <SortableTabHeader label={<IntlMessage messageId="common.user" Store={Store}/>}
                                           columnName="employee_id" column={column} order={order} setColumn={setColumn}
                                           setOrder={setOrder} setPageNumber={setPageNumber} setFetchData={setFetchData}
                                           style={{width: '10%'}}/></tr>
                    </thead>
                    <tbody> {DataHolder} </tbody>
                </Table>
                <div className={'float-start'}>
                    <Form.Select style={{width: '70px'}} className={'float-start'} onChange={(e) => reloadRow(e)}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                    </Form.Select>
                    <span className={'float-start p-2'}><IntlMessage messageId="inbox.rowperpage" Store={Store}/></span>
                </div>

                <PaginationApi
                    length={responseRecordAll.pagination.maxPages}
                    active={pageNumber}
                    setActive={setPageNumber}
                    setFetchData={setFetchData}
                />
                <WorkLogCommentModal
                    entry={selectedEntry}
                    show={showCommentModal}
                    onClose={handleCloseCommentModal}
                    showToast={showToast}
                    Store={Store}
                    users={users}
                />
            </>
        )
    } else {
        return <SpinnerJSX messageId={'common.loading'}/>
    }
}